import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["width"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Slider, InputNumber, Col } from "antd";
import { Utils } from "@react-awesome-query-builder/ui";
var _Utils$ReactUtils = Utils.ReactUtils,
  useOnPropsChanged = _Utils$ReactUtils.useOnPropsChanged,
  pureShouldComponentUpdate = _Utils$ReactUtils.pureShouldComponentUpdate;
var SliderWidget = /*#__PURE__*/function (_Component) {
  function SliderWidget(props) {
    var _this;
    _classCallCheck(this, SliderWidget);
    _this = _callSuper(this, SliderWidget, [props]);
    _this.state = {};
    _this.handleChange = function (val) {
      var internalValue = _this.state.internalValue;
      var optimizeRenderWithInternals = _this.props.config.settings.optimizeRenderWithInternals;
      if (val === "") val = undefined;
      if (optimizeRenderWithInternals) _this.setState({
        internalValue: val
      });
      var didEmptinessChanged = !!val !== !!internalValue;
      var __isInternal = optimizeRenderWithInternals && !didEmptinessChanged;
      _this.props.setValue(val, undefined, {
        __isInternal: __isInternal
      });
    };
    _this.tipFormatter = function (val) {
      return val != undefined ? val.toString() : undefined;
    };
    _this.shouldComponentUpdate = function (nextProps, nextState) {
      var optimizeRenderWithInternals = nextProps.config.settings.optimizeRenderWithInternals;
      var should = _this.pureShouldComponentUpdate(nextProps, nextState);
      if (should) {
        // RHL fix
        if (_this.props.cacheBusterProp && optimizeRenderWithInternals) {
          nextState.internalValue = _this.state.internalValue;
        }
      }
      return should;
    };
    _this.pureShouldComponentUpdate = pureShouldComponentUpdate(_this);
    useOnPropsChanged(_this);
    _this.state.internalValue = props.value;
    return _this;
  }
  _inherits(SliderWidget, _Component);
  return _createClass(SliderWidget, [{
    key: "onPropsChanged",
    value: function onPropsChanged(nextProps) {
      this.setState({
        internalValue: nextProps.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        config = _this$props.config,
        placeholder = _this$props.placeholder,
        customProps = _this$props.customProps,
        value = _this$props.value,
        min = _this$props.min,
        max = _this$props.max,
        step = _this$props.step,
        marks = _this$props.marks,
        readonly = _this$props.readonly,
        errorMessage = _this$props.errorMessage;
      var internalValue = this.state.internalValue;
      var _config$settings = config.settings,
        renderSize = _config$settings.renderSize,
        showErrorMessage = _config$settings.showErrorMessage,
        defaultSliderWidth = _config$settings.defaultSliderWidth,
        optimizeRenderWithInternals = _config$settings.optimizeRenderWithInternals;
      var _ref = customProps || {},
        width = _ref.width,
        rest = _objectWithoutProperties(_ref, _excluded);
      var customInputProps = rest.input || {};
      var customSliderProps = rest.slider || rest;
      var canUseInternal = optimizeRenderWithInternals && (showErrorMessage ? true : !errorMessage);
      var aValue = canUseInternal ? internalValue : value;
      if (aValue == undefined) aValue = null;
      var sliderValue = aValue == null && min ? min : aValue;
      return /*#__PURE__*/React.createElement(Col, {
        style: {
          display: "inline-flex",
          flexWrap: "wrap"
        }
      }, /*#__PURE__*/React.createElement(Col, {
        style: {
          "float": "left",
          marginRight: "5px"
        }
      }, /*#__PURE__*/React.createElement(InputNumber, _extends({
        disabled: readonly,
        size: renderSize,
        value: aValue,
        min: min,
        max: max,
        step: step,
        placeholder: placeholder,
        onChange: this.handleChange
      }, customInputProps))), /*#__PURE__*/React.createElement(Col, {
        style: {
          "float": "left",
          width: width || defaultSliderWidth
        }
      }, /*#__PURE__*/React.createElement(Slider, _extends({
        disabled: readonly,
        value: sliderValue,
        tooltip: {
          formatter: this.tipFormatter
        },
        min: min,
        max: max,
        included: false,
        step: step,
        marks: marks,
        onChange: this.handleChange
      }, customSliderProps))), /*#__PURE__*/React.createElement(Col, {
        style: {
          clear: "both"
        }
      }));
    }
  }]);
}(Component);
SliderWidget.propTypes = {
  setValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  config: PropTypes.object.isRequired,
  field: PropTypes.any,
  value: PropTypes.number,
  customProps: PropTypes.object,
  fieldDefinition: PropTypes.object,
  readonly: PropTypes.bool,
  // from fieldSettings:
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  marks: PropTypes.object
};
SliderWidget.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  marks: undefined
};
export { SliderWidget as default };